module.exports = __webpack_public_path__ + "static/logo_ssafe-f09ece96bc98c57ae2133bfdffa738df.svg";